// 073漫画网 mock 数据（未连接后端时的展示数据）

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  tags: string[];
  categoryIds: string[];
  status: '连载中' | '已完结';
  totalChapters: number;
  latestChapter: string;
  updateTime: string;
  views: number;
  likes: number;
  rating: number;
  isHot?: boolean;
  isNew?: boolean;
  isRecommend?: boolean;
}

export interface ChapterItem {
  id: string;
  title: string;
  updateTime: string;
}

export interface MangaChapters {
  mangaId: string;
  chapters: ChapterItem[];
}

export interface Comment {
  id: string;
  mangaId: string;
  user: string;
  content: string;
  time: string;
  likes: number;
}

export const categories: Category[] = [
  {
    id: 'cat-fitness',
    name: '健身题材',
    slug: 'fitness',
    description: '以健身、运动、力量训练为主题的漫画，汗水与热血交织的励志故事。',
  },
  {
    id: 'cat-youth',
    name: '热血青春',
    slug: 'youth',
    description: '校园与竞技的热血青春漫画，少年们为梦想全力奔跑。',
  },
  {
    id: 'cat-city',
    name: '都市职场',
    slug: 'city',
    description: '都市职场与商业奋斗题材，成年人的拼搏与成长故事。',
  },
  {
    id: 'cat-romance',
    name: '恋爱日常',
    slug: 'romance',
    description: '甜蜜治愈的恋爱日常漫画，心跳加速的浪漫瞬间。',
  },
  {
    id: 'cat-comedy',
    name: '搞笑日常',
    slug: 'comedy',
    description: '轻松搞笑的日常漫画，笑点密集，快乐加倍。',
  },
  {
    id: 'cat-fantasy',
    name: '玄幻修真',
    slug: 'fantasy',
    description: '玄幻修真的奇幻世界，灵力觉醒，逆天改命。',
  },
  {
    id: 'cat-suspense',
    name: '悬疑推理',
    slug: 'suspense',
    description: '烧脑悬疑与推理漫画，层层迷雾等你揭开真相。',
  },
];

export const mangas: Manga[] = [
  {
    id: 'm1',
    title: '健身教练',
    author: '073工作室',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20book%20cover%20illustration%2C%20a%20muscular%20confident%20personal%20fitness%20trainer%20standing%20in%20a%20modern%20gym%20with%20dumbbells%2C%20dramatic%20warm%20orange%20rim%20lighting%2C%20heroic%20pose%2C%20bold%20clean%20vector%20comic%20art%20style%2C%20vibrant%20orange%20red%20and%20gold%20color%20palette%2C%20energetic%2C%20high%20detail&width=600&height=900&seq=cover-fitness-coach&orientation=portrait',
    description:
      '《健身教练》是073漫画网免费连载的热血健身漫画。主人公陈野初入铁馆，从一名瘦弱的健身小白，在王牌教练铁哥的指导下，一步步突破极限、重塑自我。这部漫画不仅有着燃爆的健身热血剧情，更包含大量实用的健身知识与饮食干货，滑动屏幕即可感受力量与汗水的故事。',
    tags: ['健身', '热血', '励志', '都市'],
    categoryIds: ['cat-fitness', 'cat-city'],
    status: '连载中',
    totalChapters: 458,
    latestChapter: '第458话 新征程',
    updateTime: '今天 09:30',
    views: 12865000,
    likes: 98600,
    rating: 9.4,
    isHot: true,
    isNew: true,
    isRecommend: true,
  },
  {
    id: 'm2',
    title: '王者之路',
    author: '飞跃漫画',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20determined%20young%20runner%20crossing%20a%20glowing%20finish%20line%20in%20a%20blazing%20stadium%2C%20fiery%20orange%20and%20gold%20background%2C%20dynamic%20manga%20action%20art%2C%20bold%20lines%2C%20energetic%20composition&width=600&height=900&seq=cover-king-road&orientation=portrait',
    description:
      '《王者之路》讲述天赋型短跑少年苏远从校队替补一步步走向全国冠军的热血青春故事。每一次起跑都是新的挑战，每一滴汗水都不会辜负坚持的人。',
    tags: ['运动', '竞技', '青春'],
    categoryIds: ['cat-youth'],
    status: '连载中',
    totalChapters: 236,
    latestChapter: '第236话 冲刺',
    updateTime: '今天 08:45',
    views: 5820000,
    likes: 45200,
    rating: 9.1,
    isHot: true,
  },
  {
    id: 'm3',
    title: '铁馆风云',
    author: '都市漫社',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20serious%20fitness%20club%20owner%20in%20a%20smart%20suit%20holding%20dumbbells%20inside%20a%20luxurious%20modern%20gym%2C%20warm%20dusk%20city%20skyline%20through%20windows%2C%20confident%20manga%20illustration%2C%20warm%20tones&width=600&height=900&seq=cover-iron-gym&orientation=portrait',
    description:
      '《铁馆风云》是一部都市职场与商业竞争题材漫画。年轻的健身俱乐部经理林皓临危受命，空降陷入危机的老牌铁馆，在一场场收购与反收购的博弈中，用实力与智慧守住热血阵地。',
    tags: ['职场', '商战', '都市'],
    categoryIds: ['cat-city'],
    status: '连载中',
    totalChapters: 312,
    latestChapter: '第312话 王者归来',
    updateTime: '昨天 22:10',
    views: 4210000,
    likes: 33100,
    rating: 8.8,
  },
  {
    id: 'm4',
    title: '恋爱吧！健身少女',
    author: '甜蜜星球',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20cute%20cheerful%20fitness%20girl%20doing%20squats%20with%20dumbbells%20in%20a%20bright%20sunny%20gym%2C%20pastel%20warm%20colors%2C%20sweet%20romance%20manga%20illustration%20style%2C%20playful%20and%20adorable&width=600&height=900&seq=cover-love-girl&orientation=portrait',
    description:
      '《恋爱吧！健身少女》讲述元气少女小雨为暗恋对象开始健身，在教练温柔的指导下逐渐蜕变的甜蜜恋爱日常。每一堂训练课，都是一次心跳加速。',
    tags: ['恋爱', '健身', '治愈'],
    categoryIds: ['cat-romance', 'cat-fitness'],
    status: '连载中',
    totalChapters: 168,
    latestChapter: '第168话 告白预备式',
    updateTime: '昨天 19:20',
    views: 3890000,
    likes: 39800,
    rating: 9.0,
    isNew: true,
    isRecommend: true,
  },
  {
    id: 'm5',
    title: '笑到变形的健身房',
    author: '爆笑工厂',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20cover%2C%20exaggerated%20funny%20cartoon%20characters%20working%20out%20with%20hilarious%20surprised%20expressions%20in%20a%20colorful%20gym%2C%20bright%20cheerful%20palette%2C%20slapstick%20humor%20manga%20art&width=600&height=900&seq=cover-funny-gym&orientation=portrait',
    description:
      '《笑到变形的健身房》是073漫画网人气搞笑漫画。这家名叫"随便练"的健身房汇集了一群画风清奇的会员，从魔性广场舞到平板支撑大赛，每一话都能让你笑到腹肌自动生成。',
    tags: ['搞笑', '日常', '健身'],
    categoryIds: ['cat-comedy', 'cat-fitness'],
    status: '连载中',
    totalChapters: 204,
    latestChapter: '第204话 快乐源泉',
    updateTime: '昨天 18:05',
    views: 3560000,
    likes: 41100,
    rating: 9.2,
    isHot: true,
    isRecommend: true,
  },
  {
    id: 'm6',
    title: '武道乾坤',
    author: '青峰文化',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20powerful%20martial%20artist%20performing%20a%20flying%20kick%20surrounded%20by%20glowing%20energy%20aura%2C%20dark%20mystical%20mountains%20background%2C%20epic%20fantasy%20manga%20illustration%2C%20dramatic%20lighting&width=600&height=900&seq=cover-wudao&orientation=portrait',
    description:
      '《武道乾坤》是热血玄幻修真漫画。少年叶辰身负神秘血脉，自青峰山问道而起，于诸天万界中破境成神。拳镇山河，剑指乾坤，一路逆天改命。',
    tags: ['玄幻', '修真', '热血'],
    categoryIds: ['cat-fantasy'],
    status: '连载中',
    totalChapters: 512,
    latestChapter: '第512话 破碎虚空',
    updateTime: '昨天 16:40',
    views: 6780000,
    likes: 52400,
    rating: 9.3,
    isHot: true,
  },
  {
    id: 'm7',
    title: '健身房的秘密',
    author: '迷雾侦探社',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20mystery%20comic%20cover%2C%20a%20dark%20mysterious%20gym%20interior%20with%20a%20shadowy%20figure%20silhouette%20and%20faint%20glowing%20equipment%2C%20moody%20noir%20atmosphere%2C%20suspense%20thriller%20manga%20illustration&width=600&height=900&seq=cover-gym-secret&orientation=portrait',
    description:
      '《健身房的秘密》是一部悬疑推理漫画。深夜的健身房总有诡异声响，侦探陆明远受托调查，却发现这间24小时健身房背后藏着惊人的秘密。',
    tags: ['悬疑', '推理', '都市'],
    categoryIds: ['cat-suspense'],
    status: '已完结',
    totalChapters: 96,
    latestChapter: '第96话 真相大白',
    updateTime: '3天前',
    views: 2650000,
    likes: 22800,
    rating: 8.6,
  },
  {
    id: 'm8',
    title: '力量觉醒',
    author: '燃魂漫画',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20teenager%20glowing%20with%20golden%20energy%20lifting%20an%20enormous%20barbell%2C%20ground%20cracking%20under%20pressure%2C%20epic%20anime%20action%20illustration%2C%20dramatic%20golden%20light%20rays&width=600&height=900&seq=cover-power-awaken&orientation=portrait',
    description:
      '《力量觉醒》讲述普通高中生阿泽偶然间觉醒了超乎常人的力量。从校园到都市，他将在力量与责任之间做出选择，成为守护他人的英雄。',
    tags: ['异能', '热血', '校园'],
    categoryIds: ['cat-youth', 'cat-fantasy'],
    status: '连载中',
    totalChapters: 287,
    latestChapter: '第287话 守护之名',
    updateTime: '4天前',
    views: 4980000,
    likes: 38700,
    rating: 9.0,
    isNew: true,
  },
  {
    id: 'm9',
    title: '都市健身王',
    author: '极限文化',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20cover%2C%20a%20muscular%20urban%20fitness%20coach%20standing%20on%20a%20rooftop%20at%20sunset%20overlooking%20the%20city%20holding%20a%20protein%20shake%2C%20cool%20confident%20pose%2C%20warm%20cinematic%20manga%20illustration&width=600&height=900&seq=cover-urban-king&orientation=portrait',
    description:
      '《都市健身王》是都市励志健身漫画。金牌私教秦朗白天在天台给学员上课，夜晚在街头练拳。他用汗水浇灌信念，誓要打造这座城市最强的健身帝国。',
    tags: ['健身', '都市', '励志'],
    categoryIds: ['cat-city', 'cat-fitness'],
    status: '连载中',
    totalChapters: 198,
    latestChapter: '第198话 商圈之争',
    updateTime: '5天前',
    views: 3120000,
    likes: 27600,
    rating: 8.9,
  },
  {
    id: 'm10',
    title: '举铁吧！兄弟',
    author: '老铁漫画',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20cover%2C%20two%20goofy%20best%20friends%20lifting%20a%20huge%20barbell%20together%20with%20funny%20grins%2C%20bright%20sunny%20outdoor%20gym%20setting%2C%20humorous%20manga%20illustration%2C%20vibrant%20colors&width=600&height=900&seq=cover-lift-brothers&orientation=portrait',
    description:
      '《举铁吧！兄弟》是搞笑日常漫画。大熊和小胖是发小兼健身搭子，两人互相坑又互相撑，从出租屋到小健身房，爆笑不断、友情满满。',
    tags: ['搞笑', '友情', '健身'],
    categoryIds: ['cat-comedy', 'cat-fitness'],
    status: '连载中',
    totalChapters: 143,
    latestChapter: '第143话 完美一rep',
    updateTime: '6天前',
    views: 2870000,
    likes: 31500,
    rating: 9.1,
    isRecommend: true,
  },
];

export const heroBanner =
  'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20wide%20banner%20illustration%2C%20a%20heroic%20muscular%20fitness%20trainer%20working%20out%20in%20a%20dramatic%20gym%20with%20warm%20golden%20backlight%2C%20sweat%20flying%2C%20motivational%20fitness%20atmosphere%2C%20bold%20comic%20art%2C%20vibrant%20orange%20and%20red%20palette%2C%20dynamic%20epic%20composition&width=1600&height=900&seq=hero-banner&orientation=landscape';

export const aboutImages = {
  gym: 'https://readdy.ai/api/search-image?query=modern%20bright%20fitness%20gym%20interior%20with%20rows%20of%20training%20equipment%2C%20warm%20natural%20sunlight%20through%20large%20windows%2C%20clean%20warm%20tones%2C%20editorial%20photography%20style%2C%20spacious%20and%20inviting&width=1600&height=900&seq=about-gym-1&orientation=landscape',
  team: 'https://readdy.ai/api/search-image?query=cheerful%20diverse%20personal%20trainer%20team%20in%20matching%20sportswear%20standing%20together%20in%20a%20gym%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20friendly%20professional%20atmosphere&width=1600&height=900&seq=about-team-1&orientation=landscape',
};

export const chapterLists: MangaChapters[] = [
  {
    mangaId: 'm1',
    chapters: [
      { id: 'm1-ch1', title: '第1话 初入铁馆', updateTime: '2026-08-12' },
      { id: 'm1-ch2', title: '第2话 第一堂课', updateTime: '2026-08-11' },
      { id: 'm1-ch3', title: '第3话 吃对才有力气', updateTime: '2026-08-10' },
      { id: 'm1-ch4', title: '第4话 瓶颈期', updateTime: '2026-08-08' },
      { id: 'm1-ch5', title: '第5话 老铁的秘密', updateTime: '2026-08-05' },
      { id: 'm1-ch6', title: '第6话 硬拉挑战', updateTime: '2026-08-02' },
      { id: 'm1-ch7', title: '第7话 深蹲三件套', updateTime: '2026-07-30' },
      { id: 'm1-ch8', title: '第8话 健身房偶遇', updateTime: '2026-07-27' },
      { id: 'm1-ch9', title: '第9话 增肌食谱', updateTime: '2026-07-24' },
      { id: 'm1-ch10', title: '第10话 第一次比赛', updateTime: '2026-07-21' },
      { id: 'm1-ch11', title: '第11话 教练的往事', updateTime: '2026-07-18' },
      { id: 'm1-ch12', title: '第12话 蜕变', updateTime: '2026-07-15' },
    ],
  },
  {
    mangaId: 'm2',
    chapters: [
      { id: 'm2-ch1', title: '第1话 起跑线', updateTime: '2026-08-10' },
      { id: 'm2-ch2', title: '第2话 破风', updateTime: '2026-08-06' },
      { id: 'm2-ch3', title: '第3话 弯道超越', updateTime: '2026-08-01' },
      { id: 'm2-ch4', title: '第4话 终点的约定', updateTime: '2026-07-28' },
    ],
  },
  {
    mangaId: 'm3',
    chapters: [
      { id: 'm3-ch1', title: '第1话 空降总裁', updateTime: '2026-08-11' },
      { id: 'm3-ch2', title: '第2话 收购风波', updateTime: '2026-08-07' },
      { id: 'm3-ch3', title: '第3话 王牌教练', updateTime: '2026-08-03' },
      { id: 'm3-ch4', title: '第4话 逆风翻盘', updateTime: '2026-07-29' },
    ],
  },
  {
    mangaId: 'm4',
    chapters: [
      { id: 'm4-ch1', title: '第1话 镜中的决心', updateTime: '2026-08-12' },
      { id: 'm4-ch2', title: '第2话 第一堂团课', updateTime: '2026-08-09' },
      { id: 'm4-ch3', title: '第3话 温柔的纠正', updateTime: '2026-08-05' },
      { id: 'm4-ch4', title: '第4话 心跳加速', updateTime: '2026-08-01' },
    ],
  },
  {
    mangaId: 'm5',
    chapters: [
      { id: 'm5-ch1', title: '第1话 奇怪的会员', updateTime: '2026-08-12' },
      { id: 'm5-ch2', title: '第2话 魔性广场舞', updateTime: '2026-08-08' },
      { id: 'm5-ch3', title: '第3话 平板支撑大赛', updateTime: '2026-08-04' },
      { id: 'm5-ch4', title: '第4话 冠军的烦恼', updateTime: '2026-07-31' },
    ],
  },
  {
    mangaId: 'm6',
    chapters: [
      { id: 'm6-ch1', title: '第1话 问道青峰山', updateTime: '2026-08-11' },
      { id: 'm6-ch2', title: '第2话 初试锋芒', updateTime: '2026-08-06' },
      { id: 'm6-ch3', title: '第3话 门派大比', updateTime: '2026-08-02' },
      { id: 'm6-ch4', title: '第4话 师父的嘱托', updateTime: '2026-07-30' },
    ],
  },
  {
    mangaId: 'm7',
    chapters: [
      { id: 'm7-ch1', title: '第1话 深夜的健身房', updateTime: '2026-08-10' },
      { id: 'm7-ch2', title: '第2话 发光的器械', updateTime: '2026-08-05' },
      { id: 'm7-ch3', title: '第3话 脚印', updateTime: '2026-08-01' },
      { id: 'm7-ch4', title: '第4话 谜团渐深', updateTime: '2026-07-27' },
    ],
  },
  {
    mangaId: 'm8',
    chapters: [
      { id: 'm8-ch1', title: '第1话 平凡的少年', updateTime: '2026-08-09' },
      { id: 'm8-ch2', title: '第2话 异变', updateTime: '2026-08-04' },
      { id: 'm8-ch3', title: '第3话 金色的力量', updateTime: '2026-07-31' },
      { id: 'm8-ch4', title: '第4话 暴走边缘', updateTime: '2026-07-26' },
    ],
  },
  {
    mangaId: 'm9',
    chapters: [
      { id: 'm9-ch1', title: '第1话 天台训练', updateTime: '2026-08-08' },
      { id: 'm9-ch2', title: '第2话 营养师上线', updateTime: '2026-08-03' },
      { id: 'm9-ch3', title: '第3话 夜晚的沙袋', updateTime: '2026-07-30' },
      { id: 'm9-ch4', title: '第4话 商圈之战', updateTime: '2026-07-25' },
    ],
  },
  {
    mangaId: 'm10',
    chapters: [
      { id: 'm10-ch1', title: '第1话 搬家', updateTime: '2026-08-07' },
      { id: 'm10-ch2', title: '第2话 同步深蹲', updateTime: '2026-08-02' },
      { id: 'm10-ch3', title: '第3话 失误不断', updateTime: '2026-07-29' },
      { id: 'm10-ch4', title: '第4话 完美一rep', updateTime: '2026-07-24' },
    ],
  },
];

export const chapterPages: Record<string, string[]> = {
  'm1-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20opening%20scene%20a%20skinny%20shy%20young%20man%20walks%20into%20a%20modern%20gym%20looking%20nervous%2C%20clean%20ink%20with%20warm%20orange%20coloring%2C%20comic%20speech%20balloons%2C%20portrait%20manga%20page%20layout%2C%20high%20detail&width=900&height=1400&seq=fc-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20a%20muscular%20personal%20trainer%20welcomes%20the%20new%20student%20with%20a%20confident%20smile%20in%20the%20gym%2C%20detailed%20manga%20illustration%2C%20warm%20tones%2C%20comic%20dialogue%20bubbles&width=900&height=1400&seq=fc-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20trainer%20demonstrates%20bench%20press%20technique%20while%20the%20student%20watches%20closely%2C%20gym%20equipment%20background%2C%20dynamic%20manga%20art%2C%20warm%20energetic%20colors&width=900&height=1400&seq=fc-ch1-p3&orientation=portrait',
  ],
  'm1-ch2': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20morning%20scene%20protagonist%20running%20outdoors%20at%20sunrise%20with%20determination%2C%20warm%20city%20background%2C%20motivational%20manga%20art%2C%20golden%20morning%20light&width=900&height=1400&seq=fc-ch2-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20protagonist%20struggling%20through%20push-ups%20while%20trainer%20counts%20encouragement%20beside%20him%2C%20close%20up%20sweat%20details%2C%20comic%20manga%20illustration&width=900&height=1400&seq=fc-ch2-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20protagonist%20checking%20his%20reflection%20in%20gym%20mirror%20noticing%20small%20muscle%20progress%2C%20hopeful%20expression%2C%20warm%20lighting%2C%20manga%20art&width=900&height=1400&seq=fc-ch2-p3&orientation=portrait',
  ],
  'm1-ch3': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20protagonist%20preparing%20healthy%20protein%20meal%20in%20a%20bright%20kitchen%2C%20fresh%20vegetables%20and%20grilled%20chicken%2C%20clean%20manga%20illustration%2C%20fresh%20tones&width=900&height=1400&seq=fc-ch3-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20intense%20dumbbell%20and%20pull%20up%20training%20session%2C%20determined%20expression%2C%20dynamic%20camera%20angle%2C%20manga%20action%20art&width=900&height=1400&seq=fc-ch3-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20group%20fitness%20class%20scene%20many%20people%20exercising%20together%20in%20a%20bright%20gym%2C%20energetic%20joyful%20atmosphere%2C%20colorful%20manga%20illustration&width=900&height=1400&seq=fc-ch3-p3&orientation=portrait',
  ],
  'm2-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20young%20athlete%20standing%20at%20the%20starting%20line%20of%20a%20school%20track%20race%2C%20determined%20eyes%2C%20dynamic%20manga%20art%2C%20warm%20stadium%20lighting&width=900&height=1400&seq=m2-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20fierce%20sprint%20scene%20with%20motion%20lines%20and%20cheering%20crowd%2C%20explosive%20speed%20feeling%2C%20energetic%20manga%20illustration&width=900&height=1400&seq=m2-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20athlete%20crossing%20finish%20line%20and%20collapsing%20with%20teammates%20celebrating%2C%20emotional%20warm%20moment%2C%20manga%20illustration&width=900&height=1400&seq=m2-ch1-p3&orientation=portrait',
  ],
  'm3-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20corporate%20office%20scene%20a%20tired%20businessman%20looking%20at%20fitness%20posters%20on%20the%20wall%2C%20city%20view%20background%2C%20manga%20illustration%20warm%20tones&width=900&height=1400&seq=m3-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20businessman%20entering%20a%20premium%20fitness%20club%20lobby%2C%20luxurious%20modern%20interior%2C%20manga%20illustration%2C%20warm%20lighting&width=900&height=1400&seq=m3-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20first%20personal%20training%20session%20with%20professional%20trainer%20and%20serious%20client%2C%20gym%20background%2C%20manga%20art&width=900&height=1400&seq=m3-ch1-p3&orientation=portrait',
  ],
  'm4-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20cute%20fitness%20girl%20looking%20at%20herself%20in%20gym%20mirror%20deciding%20to%20get%20in%20shape%2C%20bright%20cheerful%20manga%20art%2C%20pastel%20tones&width=900&height=1400&seq=m4-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20girl%20doing%20her%20first%20group%20aerobics%20class%20nervously%2C%20colorful%20bright%20gym%2C%20cute%20romance%20manga%20illustration&width=900&height=1400&seq=m4-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20a%20kind%20handsome%20coach%20helping%20the%20girl%20with%20correct%20squat%20form%2C%20sweet%20blushing%20moment%2C%20romance%20manga%20art&width=900&height=1400&seq=m4-ch1-p3&orientation=portrait',
  ],
  'm5-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20a%20chubby%20man%20trying%20to%20squeeze%20into%20a%20tight%20fitness%20machine%20causing%20funny%20chaos%2C%20exaggerated%20cartoon%20manga%20art%2C%20bright%20colors&width=900&height=1400&seq=m5-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20gym%20members%20doing%20a%20ridiculous%20dance%20workout%20routine%2C%20all%20laughing%2C%20hilarious%20manga%20illustration&width=900&height=1400&seq=m5-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20workout%20instructor%20doing%20a%20funny%20face%20after%20holding%20plank%20too%20long%2C%20sweat%20drop%20comedy%20manga%20art&width=900&height=1400&seq=m5-ch1-p3&orientation=portrait',
  ],
  'm6-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20comic%20panel%20page%2C%20young%20cultivator%20meditating%20in%20a%20misty%20mountain%20temple%20at%20dawn%2C%20epic%20fantasy%20manga%20art%2C%20mystical%20atmosphere&width=900&height=1400&seq=m6-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20comic%20panel%20page%2C%20martial%20artist%20sparring%20in%20an%20ancient%20arena%20with%20energy%20waves%2C%20dynamic%20action%20manga%20illustration&width=900&height=1400&seq=m6-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20comic%20panel%20page%2C%20disciple%20bowing%20to%20a%20wise%20old%20master%20as%20the%20sun%20sets%20over%20mountains%2C%20emotional%20fantasy%20manga%20art&width=900&height=1400&seq=m6-ch1-p3&orientation=portrait',
  ],
  'm7-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20suspense%20comic%20panel%20page%2C%20a%20detective%20entering%20a%20dimly%20lit%20gym%20late%20at%20night%2C%20mysterious%20atmosphere%2C%20noir%20manga%20illustration&width=900&height=1400&seq=m7-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20suspense%20comic%20panel%20page%2C%20strange%20glowing%20fitness%20equipment%20found%20behind%20a%20locked%20door%2C%20eerie%20lighting%2C%20thriller%20manga%20art&width=900&height=1400&seq=m7-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20suspense%20comic%20panel%20page%2C%20detective%20examining%20a%20suspicious%20footprint%20near%20the%20treadmill%2C%20dramatic%20shadows%2C%20mystery%20manga%20illustration&width=900&height=1400&seq=m7-ch1-p3&orientation=portrait',
  ],
  'm8-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20ordinary%20high%20school%20student%20carrying%20heavy%20school%20bags%2C%20city%20street%20morning%2C%20energetic%20manga%20art%20warm%20tones&width=900&height=1400&seq=m8-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20student%20discovering%20super%20strength%20while%20lifting%20a%20heavy%20desk%20at%20school%2C%20shocked%20classmates%2C%20epic%20manga%20art&width=900&height=1400&seq=m8-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20glowing%20golden%20power%20surging%20around%20the%20student%20in%20the%20school%20gym%2C%20dramatic%20energy%2C%20action%20manga%20illustration&width=900&height=1400&seq=m8-ch1-p3&orientation=portrait',
  ],
  'm9-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20rooftop%20training%20scene%20fitness%20coach%20doing%20pull%20ups%20against%20city%20sunset%20skyline%2C%20cinematic%20manga%20art%20warm%20golden%20light&width=900&height=1400&seq=m9-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20coach%20giving%20nutrition%20advice%20to%20clients%20on%20a%20rooftop%20patio%2C%20casual%20professional%20scene%2C%20manga%20illustration&width=900&height=1400&seq=m9-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20panel%20page%2C%20night%20city%20street%20boxing%20training%20with%20heavy%20bag%2C%20cool%20urban%20atmosphere%2C%20dynamic%20manga%20art&width=900&height=1400&seq=m9-ch1-p3&orientation=portrait',
  ],
  'm10-ch1': [
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20two%20best%20friends%20carrying%20a%20giant%20barbell%20into%20a%20small%20apartment%20gym%2C%20funny%20cramped%20scene%2C%20humorous%20manga%20art&width=900&height=1400&seq=m10-ch1-p1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20both%20friends%20falling%20over%20while%20trying%20to%20do%20synchronized%20squats%2C%20hilarious%20manga%20illustration%2C%20bright%20colors&width=900&height=1400&seq=m10-ch1-p2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20comic%20panel%20page%2C%20friends%20celebrating%20after%20finally%20completing%20one%20perfect%20rep%20with%20confetti%2C%20heartwarming%20funny%20manga%20art&width=900&height=1400&seq=m10-ch1-p3&orientation=portrait',
  ],
};

export const comments: Comment[] = [
  {
    id: 'cmt-1',
    mangaId: 'm1',
    user: '举铁十年',
    content: '从第一话追到现在，看着陈野从一个瘦弱的小白变成现在的样子，真的热泪盈眶！健身漫画里的天花板，作者对训练细节的把握太专业了。',
    time: '2026-08-13 22:14',
    likes: 1286,
  },
  {
    id: 'cmt-2',
    mangaId: 'm1',
    user: '蛋白粉兑水',
    content: '每周最期待的就是《健身教练》更新！第458话"新征程"看完，感觉自己也该去健身房报到了，哈哈。',
    time: '2026-08-13 20:47',
    likes: 932,
  },
  {
    id: 'cmt-3',
    mangaId: 'm1',
    user: '铁馆扫地僧',
    content: '作为三年私教，负责任地说这部漫画里的训练动作和饮食科普都是靠谱的，很多会员看了漫画来问我动作，科普效果满分！',
    time: '2026-08-12 18:02',
    likes: 2105,
  },
  {
    id: 'cmt-4',
    mangaId: 'm1',
    user: '早起跑步的猫',
    content: '剧情不拖沓，燃点密集，铁哥的人设真的爱了。下拉式阅读体验也很舒服，一刷就是一百话。',
    time: '2026-08-12 09:33',
    likes: 768,
  },
  {
    id: 'cmt-5',
    mangaId: 'm1',
    user: '哑铃爱好者',
    content: '本来是来073漫画网找热血漫画的，结果被《健身教练》圈粉了，连着追了三天三夜，强烈安利！',
    time: '2026-08-11 15:26',
    likes: 654,
  },
  {
    id: 'cmt-6',
    mangaId: 'm1',
    user: '陈野后援会',
    content: '画面分镜超有张力，尤其是深蹲挑战那几话，隔着屏幕都能感受到大腿的酸痛（不是）。希望主角早日拿下全国赛冠军！',
    time: '2026-08-10 11:58',
    likes: 543,
  },
];